import Box from "@mui/material/Box";

export default function ({children}) {
    return (
        <Box overflow={"hidden"}>
            {children}
        </Box>
    )
}